'use client';

import React, { useState } from 'react';
import ContactMethods from './ContactMethods';
import ContactFormWizard from './ContactFormWizard';
import FAQSection from './FAQSection';

interface ContactInteractiveProps {
  className?: string;
}

const ContactInteractive = ({ className = '' }: ContactInteractiveProps) => {
  const [selectedMethod, setSelectedMethod] = useState<string | null>(null);

  const handleMethodSelect = (methodId: string) => {
    setSelectedMethod(methodId);
  };

  const handleCloseForm = () => {
    setSelectedMethod(null);
  };

  return (
    <>
      <ContactMethods onMethodSelect={handleMethodSelect} className={className} />
      <FAQSection />
      {selectedMethod && <ContactFormWizard selectedMethod={selectedMethod} onClose={handleCloseForm} />}
    </>
  );
};

export default ContactInteractive;